export class SeoService {
  static getPageTitle(page: string) {
    return `${page} | Allen Privacy`;
  }
}
